// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__QzKKW","item":"Tags_item__VmV7n"};